/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import RangePicker from '@home/components/RangePicker';
import './index.scss';
import CommonBubble from '@home/components/CommonBubble';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import { getReleaseTimeFilterValue } from '../../utils/utils';
import classNames from 'classnames';

// 品类游戏筛选器
export const RangeDateFilter = (props: any): React.ReactElement => {
  const {
    tipsInfo,
    typeList,
    value = [],
    onChange,
    setDateValue,
    filterKey,
    isReseted,
    ...restProps
  } = props || {};
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  // 筛选求日期值
  const [filterValue, setFilterValue] = useState(value);
  // 筛选器粒度
  const [granularity, setGranularity] = useState('date');
  // 如点击reset则重置筛选器为空
  useEffect(() => {
    if(isReseted){
      setFilterValue([]);
    }
  }, [isReseted]);
  return (
    <div
      className={classNames('dbb-date-range-filter-wrapper', {
        'dbb-date-range-filter-wrapper-cn': !isEn,
      })}
    >
      <CommonBubble
        content={tipsInfo}
        placementOffset={[190, 10]}
        flipped={false}
      >
        <RangePicker
          type={granularity}
          value={filterValue}
          className="dbb-date-range-filter-wrapper-range-picker"
          overlayClassName="dbb-date-range-filter-wrapper-type-overlay"
          language={isEn ? 'en' : 'cn'}
          typeList={typeList}
          onChange={(value: string, type: string) => {
            onChange(filterKey, getReleaseTimeFilterValue({startDate: value[0], endDate: value[1], dateType: granularity}));
            setFilterValue(value);
            setGranularity(type);
          }}
          isReseted
          {...restProps}
        />
      </CommonBubble>
    </div>
  );
};
